import React, { Component, useState } from "react";

import { Row, Col, Tabs } from "antd";
import { Margin } from "styled-components-spacing";
import Center from "react-center";

import ManagerTab from "../HumanResourceCom/ManagerTab.js";
import ManagerTab1 from "../HumanResourceCom/ManagerTab1.js";
import DirectorsTab from "../HumanResourceCom/DirectorsTab.js";
import HeadsTab from "../HumanResourceCom/HeadsTab.js";

// CSS Files
import "../../../Fonts/Fonts.css";
import "../../../Statics/AboutUs/HumanResource/HumanResource.css";
import DeputyTab from "./DeputyTab.js";
import ChairmanTab from "./ChairmanTab.js";

const tabStyle = {
  fontSize: ".8em",
  fontFamily: "IRANSans",
  paddingRight: "20px",
  paddingLeft: "20px",
  width: "150px",
  textAlign: "center",
};
const tabStyleClick = {
  fontSize: ".8em",
  fontFamily: "IRANSans",
  paddingRight: "20px",
  paddingLeft: "20px",
  width: "150px",
  textAlign: "center",
  boxShadow: "0 10px 20px rgba(0, 0, 0, 0.2)",
  color: "#fff",
  backgroundColor: " #186491",
};
const tabStyleTablet = {
  fontSize: ".75em",
  fontFamily: "IRANSans",
  paddingRight: "20px",
  paddingLeft: "20px",
  width: "125px",
  textAlign: "center",
};
const tabStyleTabletClick = {
  fontSize: ".75em",
  fontFamily: "IRANSans",
  paddingRight: "20px",
  paddingLeft: "20px",
  width: "125px",
  textAlign: "center",
  boxShadow: "0 10px 20px rgba(0, 0, 0, 0.2)",
  color: "#fff",
  backgroundColor: " #186491",
};

const { TabPane } = Tabs;

function callback(key) {
  console.log(key);
}

const HumanResourcceTabs = (props) => {
  const [change, setChange] = useState("0");
  return props.size === "laptopdesktop" ? (
    <div className="humanResourceBackground">
      <div style={{ paddingTop: "100px" }}>
        <Center>
          <p className="mainTitle mainTitleBorderRight mainTitleBorderLeft">
            <strong>با ما آشنا شوید</strong>
          </p>
        </Center>
        <Center>
          <Margin top={2}>
            <p className="mainTitleDescription">
              معرفی سرمایه انسانی ایرانیان پوشش
            </p>
          </Margin>
        </Center>
      </div>
      <Row style={{ marginTop: "75px" }}>
        <hr
          style={{
            border: "0.01em dashed #4983C4",
            width: "100%",
            marginTop: "0px",
          }}
        />
      </Row>
      <Row
        className="tabs clearfix"
        data-tabgroup="first-tab-group"
        style={{ marginTop: "-35px" }}
      >
        <Col span={7}></Col>
        <Col span={3} style={{ direction: "rtl", textAlign: "right" }}>
          <a
            href="#tab4"
            class="humanResourceBtn humanResourceBtn-white humanResourceBtn-animated"
            name="4"
            onClick={(e) => setChange(e.target.name)}
            style={change == 4 ? tabStyleClick : tabStyle}
          >
            رئیس اداره
          </a>
        </Col>
        <Col span={3} style={{ direction: "rtl", textAlign: "right" }}>
          <a
            href="#tab3"
            class="humanResourceBtn humanResourceBtn-white humanResourceBtn-animated"
            name="3"
            onClick={(e) => setChange(e.target.name)}
            style={change == 3 ? tabStyleClick : tabStyle}
          >
            مدیران{" "}
          </a>
        </Col>
        <Col span={3} style={{ direction: "rtl", textAlign: "right" }}>
          <a
            href="#tab2"
            class="humanResourceBtn humanResourceBtn-white humanResourceBtn-animated"
            name="2"
            onClick={(e) => setChange(e.target.name)}
            style={change == 2 ? tabStyleClick : tabStyle}
          >
            معاون
          </a>
        </Col>
        <Col span={3} style={{ direction: "rtl", textAlign: "right" }}>
          <a
            href="#tab1"
            class="humanResourceBtn humanResourceBtn-white humanResourceBtn-animated"
            name="1"
            onClick={(e) => setChange(e.target.name)}
            style={change == 1 ? tabStyleClick : tabStyle}
          >
            مدیرعامل
          </a>
        </Col>
        <Col span={3} style={{ direction: "rtl", textAlign: "right" }}>
          <a
            href="#tab0"
            class="humanResourceBtn humanResourceBtn-white humanResourceBtn-animated"
            name="0"
            onClick={(e) => setChange(e.target.name)}
            style={change == 0 ? tabStyleClick : tabStyle}
          >
            رئیس هیئت مدیره
          </a>
        </Col>
        <Col span={2}></Col>
      </Row>
      <section id="first-tab-group" class="tabgroup">
        <div id="tab0">
          <Margin top={5}>
            <ChairmanTab size="laptopdesktop" />
          </Margin>
        </div>
        <div id="tab1">
          <Margin top={5}>
            <ManagerTab1 size="laptopdesktop" />
          </Margin>
        </div>
        <div id="tab2">
          <Margin top={5}>
            <DeputyTab size="laptopdesktop" />
          </Margin>
        </div>
        <div id="tab3">
          <Margin top={5}>
            <DirectorsTab size="laptopdesktop" />
          </Margin>
        </div>
        <div id="tab4">
          <Margin top={5}>
            <HeadsTab size="laptopdesktop" />
          </Margin>
        </div>
      </section>
    </div>
  ) : props.size === "tablet" ? (
    <div className="humanResourceBackground">
      <div style={{ paddingTop: "75px" }}>
        <Center>
          <p className="mainTitleTablet mainTitleBorderRight mainTitleBorderLeft">
            <strong>با ما آشنا شوید</strong>
          </p>
        </Center>
        <Center>
          <Margin top={2}>
            <p className="mainTitleDescriptionTablet">
              معرفی سرمایه انسانی ایرانیان پوشش
            </p>
          </Margin>
        </Center>
      </div>
      <Row style={{ marginTop: "25px" }}>
        <hr
          style={{
            border: "0.01em dashed #4983C4",
            width: "100%",
            marginTop: "0px",
          }}
        />
      </Row>
      <Tabs
        defaultActiveKey="0"
        centered
        style={{ fontFamily: "IranSans", textAlign: "center" }}
      >
        <TabPane tab="رئیس اداره" key="4">
          <HeadsTab />
        </TabPane>
        <TabPane tab="مدیران" key="3">
          <DirectorsTab />
        </TabPane>
        <TabPane tab="معاون" key="2">
          <DeputyTab />
        </TabPane>

        <TabPane tab="مدیرعامل" key="1">
          <ManagerTab1 />
        </TabPane>
        <TabPane tab="رئیس هیئت مدیره" key="0">
          <ChairmanTab />
        </TabPane>
      </Tabs>
    </div>
  ) : (
    <div className="humanResourceBackground">
      <div style={{ paddingTop: "75px" }}>
        <Center>
          <p className="mainTitleMobile mainTitleBorderRightMobile mainTitleBorderLeftMobile">
            <strong>با ما آشنا شوید</strong>
          </p>
        </Center>
        <Center>
          <Margin top={2}>
            <p className="mainTitleDescriptionMobile">
              معرفی سرمایه انسانی ایرانیان پوشش
            </p>
          </Margin>
        </Center>
      </div>
      <Tabs
        defaultActiveKey="0"
        centered
        style={{ fontFamily: "IranSans", textAlign: "center" }}
      >
        <TabPane tab="رئیس اداره" key="4">
          <HeadsTab />
        </TabPane>
        <TabPane tab="مدیران" key="3">
          <DirectorsTab />
        </TabPane>
        <TabPane tab="معاون" key="2">
          <DeputyTab />
        </TabPane>

        <TabPane tab="مدیرعامل" key="1">
          <ManagerTab1 />
        </TabPane>
        <TabPane tab="رئیس هیئت مدیره" key="0">
          <ChairmanTab />
        </TabPane>
      </Tabs>
    </div>
  );
};

export default HumanResourcceTabs;
